import { Grid, TextField, MenuItem, Box } from "@mui/material";
import DateRangePicker from "@mui/lab/DateRangePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import colors from "../../../../../colors";
import React from "react";

const DefaultView = ({
  franchise,
  handleFranchiseChange,
  classes,
  props,
  zone,
  handleZoneChange,
  section,
  handleSectionChange,
  dateRange,
  setDateRange,
  fathersName,
  setFathersName,
}) => {
  return (
    <>
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          select
          label="Franshiza"
          value={franchise}
          onChange={handleFranchiseChange}
          color="warning"
          size="small"
          className={classes.textField}
        >
          {props.utilitySliceState.franchaise &&
            props.utilitySliceState.franchaise.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
        </TextField>
      </Grid>
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          select
          label="Zona"
          value={zone}
          onChange={handleZoneChange}
          color="warning"
          size="small"
          className={classes.textField}
          disabled={props.utilitySliceState.zone.length === 0}
        >
          {props.utilitySliceState.zone &&
            props.utilitySliceState.zone.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
        </TextField>
      </Grid>
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          select
          label="Seksioni"
          value={section}
          onChange={handleSectionChange}
          color="warning"
          size="small"
          className={classes.textField}
          disabled={props.utilitySliceState.sections.length === 0}
        >
          {props.utilitySliceState.sections &&
            props.utilitySliceState.sections.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
        </TextField>
      </Grid>
      <Grid container item md={12} justifyContent="flex-start">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateRangePicker
            inputFormat="dd/MM/yyyy"
            startText="Datë fillimi"
            endText="Datë mbarimi"
            disabled={section === ""}
            disablePast
            value={dateRange}
            onChange={(newDateRange) => setDateRange(newDateRange)}
            renderInput={(startProps, endProps) => (
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <TextField
                  {...startProps}
                  variant="outlined"
                  size={"small"}
                  color={"warning"}
                  sx={{
                    background: colors.white,
                  }}
                />
                <Box sx={{ mx: { md: 5, sm: 1, xs: 1 } }}> në</Box>
                <TextField
                  {...endProps}
                  variant="outlined"
                  size={"small"}
                  color={"warning"}
                  sx={{
                    background: colors.white,
                  }}
                />
              </Grid>
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          label="Atësia"
          size="small"
          color="warning"
          value={fathersName}
          onChange={setFathersName}
          className={classes.textField}
        />
      </Grid>
    </>
  );
};

export default DefaultView;
